import { createContext, useContext } from 'react';
import type { RoleEditorContextValue } from './types';

/**
 * Shared non-form state for every part of the editor (sidebar, header,
 * sections, footer). RHF state goes through FormProvider/useFormContext —
 * this context only carries everything *outside* the RHF model:
 * permissions config, approver list, computed approval chain, active
 * section, mobile-user toggle, etc.
 */
export const RoleEditorContext = createContext<RoleEditorContextValue | null>(null);

export function useRoleEditorContext(): RoleEditorContextValue {
  const ctx = useContext(RoleEditorContext);
  if (!ctx) {
    throw new Error(
      'useRoleEditorContext must be used inside <RoleEditorProvider>. ' +
        'Check that the section component is rendered as a child of <RoleEditor>.',
    );
  }
  return ctx;
}
